<template>
  <div v-if="exibirPopupConsentimento" class="c-popup-consentimento">
    <!-- <p class="c-popup-consentimento__titulo">Política de Cookies</p> -->
    <div class="c-popup-consentimento__header">
      <div class="c-popup-consentimento__titulo-wrapper">
        <Button
          v-if="exibirModalPreferenciasCookies"
          class="c-popup-consentimento__voltar"
          size="TINY"
          @click="exibirModalPreferenciasCookies = false"
        >
          <svg
            class="c-svg-symbol c-popup-consentimento__icon"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </Button>
        <p class="c-popup-consentimento__titulo">
          {{
            exibirModalPreferenciasCookies
              ? 'Preferências de Cookies'
              : 'Sua privacidade'
          }}
        </p>
      </div>
      <div
        v-if="!exibirModalPreferenciasCookies"
        class="c-popup-consentimento__resumo"
      >
        <p>
          Utilizamos cookies e tecnologias semelhantes para nos ajudar a
          oferecer uma experiência melhor. Ao clicar em "Continuar" você indica
          que leu e concorda com nossa
          <a :href="url('/politica-de-cookies')">Política de Cookies</a> e
          <a :href="url('/politica-de-privacidade')">Política de Privacidade</a
          >.
        </p>
      </div>
    </div>
    <div
      v-if="exibirModalPreferenciasCookies && configuracoes"
      class="c-popup-consentimento__body"
    >
      <div class="c-popup-consentimento__conteudo">
        <div
          v-for="categoria in configuracoes.categories"
          :key="categoria.name"
          class="c-modal-consentimento__secao"
        >
          <p class="c-modal-consentimento__secao-titulo">
            {{ categoria.name }}
          </p>
          <p class="c-modal-consentimento__secao-resumo">
            {{ categoria.description }}
          </p>
          <div>
            <div
              v-for="service in categoria.services"
              :key="service.name"
              class="c-modal-consentimento__secao-item"
            >
              <span>{{ service.name }}</span>
              <ToggleSwitch
                :value="service.checked"
                :name="service.name"
                :disabled="service.mandatory"
                @input="updateServiceStatus($event, service)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="c-popup-consentimento__footer">
      <div class="c-popup-consentimento__botoes">
        <Button
          size="SMALL"
          center
          outline
          :active="exibirModalPreferenciasCookies"
          @click="
            exibirModalPreferenciasCookies = !exibirModalPreferenciasCookies
          "
          >Preferências de Cookies</Button
        >
        <Button
          size="SMALL"
          center
          reverse-secondary
          data-test-id="cconsent-submit-button"
          @click="salvarConfiguracao"
          >Continuar</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../Button/Button'
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch'
import { url } from '../../../utils/url'

export default {
  name: 'PopupConsentimento',
  components: {
    Button,
    ToggleSwitch,
  },
  data() {
    return {
      exibirPopupConsentimento: false,
      exibirModalPreferenciasCookies: false,
      configuracoes: null,
    }
  },
  mounted() {
    if (
      window.CConsentManager &&
      window.CConsentManager.config &&
      window.CConsentManager.config.active
    ) {
      window.CConsentManager.addEventListener(
        'updateVisibility',
        this.updatePopupVisibility
      )

      this.init()
    }
  },
  methods: {
    init() {
      this.configuracoes = window.CConsentManager.config
      this.updatePopupVisibility(window.CConsentManager.config.showPopup)
    },
    updatePopupVisibility(status) {
      this.exibirModalPreferenciasCookies = false
      this.exibirPopupConsentimento = status
    },
    salvarConfiguracao() {
      window.CConsentManager.save()
      window.setTimeout(() => {
        this.updatePopupVisibility(window.CConsentManager.config.showPopup)
      }, 0)
    },
    updateServiceStatus(status, service) {
      service.wanted = status
      service.checked = status
    },
    url(path = '/') {
      return url(path)
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '../../../../sass/_www/variables.global.styl'

.c-popup-consentimento
  display flex
  flex-direction column
  position fixed
  bottom 0
  left 0
  z-index 9999999
  margin 0
  max-width $base-breakpoint-fullhd
  background #fff
  box-shadow rgba(0, 0, 0, 0.2) 0px 0 18px
  border-radius 12px 12px 0 0
  max-height "calc(100% - %s * 6)" % $base-spacing-unit
  max-width 540px

  &__header
    padding $base-spacing-unit * 1.5 $base-spacing-unit * 2
  &__icon
    margin-left 0
    width 20px
    height 20px
  &__footer
    padding $base-spacing-unit $base-spacing-unit * 2
    border-top 1px solid rgba(72, 72, 72, 0.15)
    flex-shrink 0

  &__body
    display flex
    flex-direction column
    overflow-y auto
    padding $base-spacing-unit * 2 $base-spacing-unit * 2
    border-top 1px solid rgba(72, 72, 72, 0.15)

  &__titulo-wrapper
    display flex
    align-items center
  &__voltar
    margin-right $base-spacing-unit
  &__voltar :deep(.c-button__content)
    display flex
  &__titulo
    font-weight 700
    font-size 15px
    margin 0
  &__resumo
    min-width 65%
    flex 1 1 0%
    font-size 13px
    margin-top 8px
  &__resumo p
    margin 0

  &__botoes
    display flex
    flex-shrink 0
    width 100%

  &__botoes :deep(.c-button):last-child
    margin-left 12px

  a
    color rgb(35, 147, 174)

  @media (min-width $base-breakpoint-small)
    border-radius $base-radius
    margin-left $base-spacing-unit * 3
    margin-right $base-spacing-unit * 3
    margin-bottom $base-spacing-unit * 3
    &__body
      padding $base-spacing-unit * 2 $base-spacing-unit * 2.5
    &__titulo
      font-size 14px
    &__botoes
      flex-direction row
      width auto

.c-modal-consentimento
  &__secao
    margin-top 16px
    margin-bottom 16px
  &__secao-titulo
    font-size 15px
    font-weight 700
    margin-bottom $base-spacing-unit
  &__secao-resumo
    margin-bottom 12px
    font-size 14px
    color rgb(72, 72, 72)
  &__secao-item
    display flex
    justify-content space-between
    align-items center
    padding 8px 0
    font-size 14px
  &__secao-item:not(:first-child)
    border-top 1px solid rgba(72, 72, 72, 0.15)
</style>
